import { Spinner } from '@/components';
import { LoggedLayout } from '@/components/LoggedLayout';
import { PropsWithChildren } from 'react';
import { useAutoSignin, withAuthenticationRequired } from 'react-oidc-context';
import AuthRedirect from '../pages/AuthRedirect';

// eslint-disable-next-line react-refresh/only-export-components
function PrivateRoute({ children }: PropsWithChildren) {
  const { isLoading, isAuthenticated, error } = useAutoSignin();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <div>Unable to log in</div>;
  }

  if (error) {
    return <div>An error occured</div>;
  }

  return <LoggedLayout>{children}</LoggedLayout>;
}

// eslint-disable-next-line react-refresh/only-export-components
export default withAuthenticationRequired(PrivateRoute, {
  OnRedirecting: () => <AuthRedirect />,
});
